// Inline failure state with retry — used per screen/section, never a blank page.
export default function ErrorState({
  title = "Couldn't load",
  message,
  onRetry,
}) {
  return (
    <div className="state-wrap">
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {onRetry && (
        <button className="morebtn" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
